import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

// Radix Select forbids an empty-string item value, so a sentinel stands in for
// the unfiltered "all" option and maps back to `undefined` in the query.
export const ALL_FILTER = "__all__";

interface FilterOption {
  value: string;
  label: string;
}

interface FilterSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  /** Label for both the trigger placeholder and the "all" sentinel option. */
  allLabel: string;
  options: FilterOption[];
  /** Trigger width/utility classes (e.g. "w-full sm:w-48"). */
  className?: string;
}

/**
 * A single server-side filter dropdown used by the admin explorers: an "all"
 * sentinel option ({@link ALL_FILTER}) followed by the caller's options.
 */
export function FilterSelect({
  value,
  onValueChange,
  allLabel,
  options,
  className,
}: FilterSelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={allLabel} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_FILTER}>{allLabel}</SelectItem>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
